<template>
  <div class="st-table">

    <el-card shadow="always" style="width: 100%">
      <el-carousel height ="100px">
        <el-carousel-item v-for="item in this.bullet" :key="item">
          <h3>{{ item['bullet'] }}</h3>
        </el-carousel-item>
      </el-carousel>
    </el-card>
    <br/>

    <div style="text-align: left;font-weight: 400;font-size:15px">
      Current Year Time-off Record
    </div>
    <br/>
    <el-card title="Leave Status" shadow="always" style="width: 100%">
          <el-form>
            <el-table
              :data="attStatus" border style="width: 100%">
<!--              <el-table-column-->
<!--                prop="user"-->
<!--                label="Name"-->
<!--              >-->
<!--              </el-table-column>-->
              <el-table-column
                prop="pto"
                label="Time Off Request – PTO (Hrs)"
              >
              </el-table-column>
              <el-table-column
                prop="upto"
                label="Time Off Request – UPTO (Hrs)"
              >
              </el-table-column>
              <el-table-column
                prop="jd"
                label="Jury Duty (Hrs)"
              >
              </el-table-column>
              <el-table-column
                prop="bereavement"
                label="BEREAVEMENT (Hrs)"
              >
              </el-table-column>
            </el-table>

          </el-form>
        </el-card>


</div>
</template>

<script>

import attendanceApi from "@/api/attendance";
import dashboardApi from "@/api/dashboard"

export default {
  name: "dashboard",
  data() {
    return {
      loading: false,
      bullet: [],
      attStatus: []
    }
  },
  computed: {
    // projects() {
    //   return this.$store.state.jira.projects
    // },
    // timeDefault() {
    //   let time1 = new Date()
    //   time1.setTime(time1.getTime() - (24 * 60 * 60 * 1000))
    //   let Y1 = time1.getFullYear()
    //   let M1 = ((time1.getMonth() + 1) > 9 ? (time1.getMonth() + 1) : '0' + (time1.getMonth() + 1))
    //   let D1 = (time1.getDate() > 9 ? time1.getDate() : '0' + time1.getDate())
    //   let timer1 = Y1 + '-' + M1 + '-' + D1 // 当前时间
    //   let time2 = new Date()
    //   // 往前30天
    //   time2.setTime(time2.getTime() - (24 * 60 * 60 * 1000 * 30))
    //   let Y2 = time2.getFullYear()
    //   let M2 = ((time2.getMonth() + 1) > 9 ? (time2.getMonth() + 1) : '0' + (time2.getMonth() + 1))
    //   let D2 = (time2.getDate() > 9 ? time2.getDate() : '0' + time2.getDate())
    //   let timer2 = Y2 + '-' + M2 + '-' + D2 // 之前的7天或者30天
    //   // console.log(timer1, timer2)
    //   return [timer2, timer1]
    // }

  },
  methods: {
    search() {
      var date = new Date();
      var nowMonth = date.getMonth() + 1;
      var strDate = date.getDate();
      var seperator = "-";
      if (nowMonth >= 1 && nowMonth <= 9) {
        nowMonth = "0" + nowMonth;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var nowDate = date.getFullYear() + seperator + nowMonth + seperator + strDate;
      let para = {}
      var dateTo = date.getFullYear() + seperator + "01" +seperator + "01"
      para['date_from'] = dateTo
      para['date_to'] = nowDate
      this.loading = true
      attendanceApi.getAttStatus(para).then(res => {
        this.attStatus = res.data.data
        this.loading = false
      })
    },
    getBullet() {
      dashboardApi.getBullet().then(res => {
        this.bullet = res.data.data
        this.loading = false
      })
    }
  },
  mounted() {
    // console.log('projs', this.$store.state.report.projects)
    // this.value = this.timeDefault
    // this.getBugSummary()
    this.search()
    this.getBullet()
  }
}
</script>


<style lang="scss" scoped>
.dashboard-header {
  height: 40px;
  margin: 0 auto;

  background-color: #fff;
  text-align: left;
  padding: 5px;
}

.dashboard-header-col {
  margin-left: 20px;
}

.el-dropdown-link {
  line-height: 30px;
  color: #409EFF;
  cursor: pointer;
  font-size: 12px;
  font-family: "Microsoft Yahei",serif;
}

.col-title-style {
  font-size: 18px;
  font-weight: 400;
  margin: 0 0 18px;
}

.col-data-style {
  font-size: 24px;
  font-weight: bolder;
}

.yBar {
  position: absolute;
  bottom: 0;
  width: 2px;
  height: 100%;
  background-color: #d9d9d9;
  border-radius: 1px;
  opacity: .8;
}
.el-carousel__item h3 {
  color: #2c2a48;
  font-size: 14px;
  opacity: 0.75;
  line-height: 100px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #d3dce6;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.st-table {
  padding:10px
}

</style>
